function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11A11 11 0 0011 0zm0 19.8a8.8 8.8 0 110-17.6 8.8 8.8 0 010 17.6zm3.41-8.107l-2.31-1.331V5.5a1.1 1.1 0 00-2.2 0v5.632c.007.076.025.15.055.22a.979.979 0 00.088.187c.03.063.067.122.11.176l.176.143.099.099 2.86 1.65a1.1 1.1 0 00.55.143 1.1 1.1 0 00.55-2.057h.022z",
  fill: "currentColor",
  fillRule: "evenodd"
})));